/**
 * 10Duke Identity Management API
 * 1.7.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: "http://example",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {
    server1: "http://example",
    server2: "https://example"
};
export type GrantedPermissionActions = {
    allowedActions: string[];
};
export type InternalPermissionWithGrantedActions = {
    name: string;
    description?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
    grantedActions?: GrantedPermissionActions;
};
export type PermissionGrantsForPermission = {
    permissionId?: string;
    grantedActions?: string[];
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type ClientPermission = {
    name: string;
    description?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type ClientRole = {
    clientIdentifier: string;
    name: string;
    description?: string;
    designator?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type OrganizationGroupInvitation = {
    organizationId: string;
    clientRoleIds?: string[];
    groupIds: string[];
    organizationRoleIds?: string[];
    invitationScopeInformation?: string;
    recipientIsNewUser?: boolean;
    recipientLanguageCode?: string;
    memberWelcomeUrl?: string;
    invitationCompletedUrl?: string;
    recipientCountryCode?: string;
    declinedAt?: string;
    clientData?: string;
    revokedAt?: string;
    claimedAt?: string;
    recipientName: string;
    inviterName: string;
    invitationState?: "accepted" | "created" | "updated" | "declined" | "deliveryRequested" | "revoked";
    memberStatus?: "invited" | "user";
    email: string;
    validFrom: string;
    validUntil?: string;
    id: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
};
export type InvitationTokenResponse = {
    email: string;
    token: string;
};
export type Organization = {
    name: string;
    "type"?: string;
    description?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type Address = {
    country?: string;
    region?: string;
    postalCode?: string;
    formatted?: string;
    locality?: string;
    streetAddress?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type User = {
    address?: Address;
    displayName?: string;
    email: string;
    lastName: string;
    firstName: string;
    phoneNumber?: string;
    lastSignOn?: string;
    nickname?: string;
    picture?: string;
    professionalTitle?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
    validUntil?: string;
    validFrom?: string;
};
export type Entitlement = {
    name: string;
    "type"?: string;
    description?: string;
    isDefault?: boolean;
    ownerUser?: User;
    ownerOrganization?: Organization;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type EntitlementConsumerGroup = {
    id: string;
    entitlementId?: string;
    groupId?: string;
};
export type OrganizationGroup = {
    name: string;
    "type"?: string;
    description?: string;
    organizationId?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type OrganizationRole = {
    organizationId?: string;
    name: string;
    description?: string;
    designator?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type CreatedOrganizationWithEntitlement = {
    entitlements?: Entitlement[];
    entitlementConsumerGroups?: EntitlementConsumerGroup[];
    groups?: OrganizationGroup[];
    initialAdminId?: string;
    organizationRoles?: OrganizationRole[];
    name: string;
    "type"?: string;
    description?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type OrganizationRoleWithPermissionsWithGrantedActions = {
    organizationId?: string;
    name: string;
    description?: string;
    designator?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
    permissions?: InternalPermissionWithGrantedActions[];
};
export type Property = {
    key: string;
    value?: string;
};
export type ExternalIdentity = {
    providerId: string;
    userId: string;
    id: string;
};
export type UserForCreate = {
    groupIds?: string[];
    externalIdentities?: ExternalIdentity[];
    organizationRoleIds?: string[];
    address?: Address;
    displayName?: string;
    email: string;
    lastName: string;
    firstName: string;
    phoneNumber?: string;
    lastSignOn?: string;
    nickname?: string;
    picture?: string;
    professionalTitle?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
    validUntil?: string;
    validFrom?: string;
};
export type Permission = {
    name: string;
    description?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type InternalRole = {
    name: string;
    description?: string;
    designator?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
export type UserInvitation = {
    internalRoles?: string[];
    invitationScopeInformation?: string;
    recipientIsNewUser?: boolean;
    recipientLanguageCode?: string;
    memberWelcomeUrl?: string;
    invitationCompletedUrl?: string;
    recipientCountryCode?: string;
    declinedAt?: string;
    clientData?: string;
    revokedAt?: string;
    claimedAt?: string;
    recipientName: string;
    inviterName: string;
    invitationState?: "accepted" | "created" | "updated" | "declined" | "deliveryRequested" | "revoked";
    memberStatus?: "invited" | "user";
    email: string;
    validFrom: string;
    validUntil?: string;
    id: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
};
export type RecoveryEmail = {
    value?: string;
    validatedAt?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
    recipientCountryCode?: string;
    recipientLanguageCode?: string;
};
export type OrganizationGroupOfUser = {
    name: string;
    "type"?: string;
    description?: string;
    organizationId?: string;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
    validUntil?: string;
    validFrom?: string;
};
export type ValidationTokenResponse = {
    email: string;
    token: string;
};
export type OtpCredential = {
    qrCode?: string;
    keyUri?: string;
    secret?: string;
    verified?: boolean;
    created?: string;
    modified?: string;
    authorId?: string;
    editorId?: string;
    id: string;
};
/**
 * List client permissions of a client role
 */
export function listClientPermissionsOfClientRole(roleId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalPermissionWithGrantedActions[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/client-roles/${encodeURIComponent(roleId)}/permissions`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add client permissions for a client role
 */
export function addClientPermissionsForClientRole(roleId: string, body?: PermissionGrantsForPermission[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/client-roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace client permissions of a client role
 */
export function setClientPermissionsOfClientRole(roleId: string, body?: PermissionGrantsForPermission[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/client-roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove client permissions of a client role
 */
export function removeClientPermissionsOfClientRole(roleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/client-roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a client permission of a client role
 */
export function getClientPermissionOfClientRole(roleId: string, permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalPermissionWithGrantedActions;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/client-roles/${encodeURIComponent(roleId)}/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts
    });
}
/**
 * Remove a client permission of a client role
 */
export function removeClientPermissionOfClientRole(roleId: string, permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/client-roles/${encodeURIComponent(roleId)}/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List client permissions
 */
export function listClientPermissions(clientId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientPermission[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-permissions`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a client permission
 */
export function createClientPermission(clientId: string, clientPermission: ClientPermission, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: ClientPermission;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-permissions`, oazapfts.json({
        ...opts,
        method: "POST",
        body: clientPermission
    }));
}
/**
 * Replace data of a client permission
 */
export function replaceClientPermission(clientId: string, clientPermission: ClientPermission, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientPermission;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-permissions`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: clientPermission
    }));
}
/**
 * Get a client permission
 */
export function getClientPermission(clientId: string, clientPermissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientPermission;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-permissions/${encodeURIComponent(clientPermissionId)}`, {
        ...opts
    });
}
/**
 * Delete a client permission
 */
export function deleteClientPermission(clientId: string, clientPermissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/clients/${encodeURIComponent(clientId)}/client-permissions/${encodeURIComponent(clientPermissionId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List client roles
 */
export function listClientRoles(clientId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-roles`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a client role
 */
export function createClientRole(clientId: string, clientRole: ClientRole, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: ClientRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body: clientRole
    }));
}
/**
 * Replace data of a client role
 */
export function replaceClientRole(clientId: string, clientRole: ClientRole, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-roles`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: clientRole
    }));
}
/**
 * Get a client role
 */
export function getClientRole(clientId: string, clientRoleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/clients/${encodeURIComponent(clientId)}/client-roles/${encodeURIComponent(clientRoleId)}`, {
        ...opts
    });
}
/**
 * Delete a client role
 */
export function deleteClientRole(clientId: string, clientRoleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/clients/${encodeURIComponent(clientId)}/client-roles/${encodeURIComponent(clientRoleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List organization invitations
 */
export function listOrganizationGroupInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create an organization invitation
 */
export function createOrganizationGroupInvitation(organizationGroupInvitation: OrganizationGroupInvitation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations", oazapfts.json({
        ...opts,
        method: "POST",
        body: organizationGroupInvitation
    }));
}
/**
 * Accept an organization invitation
 */
export function acceptOrganizationGroupInvitation(body: {
    token: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/accept", oazapfts.form({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List accepted organization invitations
 */
export function listAcceptedOrganizationGroupInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/accepted", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Decline an organization invitation
 */
export function declineOrganizationGroupInvitation(body: {
    token: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/decline", oazapfts.form({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List declined organization invitations
 */
export function listDeclinedOrganizationGroupInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/declined", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * List open organization invitations
 */
export function listOpenOrganizationGroupInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/open", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * List revoked organization invitations
 */
export function listRevokedOrganizationGroupInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/revoked", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create and send an organization invitation
 */
export function createAndSendOrganizationGroupInvitation(organizationGroupInvitation: OrganizationGroupInvitation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organization-group-invitations/send", oazapfts.json({
        ...opts,
        method: "POST",
        body: organizationGroupInvitation
    }));
}
/**
 * Get an organization invitation
 */
export function getOrganizationGroupInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organization-group-invitations/${encodeURIComponent(invitationId)}`, {
        ...opts
    });
}
/**
 * Delete an organization invitation
 */
export function deleteOrganizationGroupInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organization-group-invitations/${encodeURIComponent(invitationId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Create a token for an organization invitation
 */
export function createOrganizationGroupInvitationToken(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InvitationTokenResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organization-group-invitations/${encodeURIComponent(invitationId)}/create-token`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Revoke an organization invitation
 */
export function revokeOrganizationGroupInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organization-group-invitations/${encodeURIComponent(invitationId)}/revoke`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Send an organization invitation
 */
export function sendOrganizationGroupInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organization-group-invitations/${encodeURIComponent(invitationId)}/send`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * List permissions of an organization role
 */
export function listPermissionsOfOrganizationRole(roleId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalPermissionWithGrantedActions[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organization-roles/${encodeURIComponent(roleId)}/permissions`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add permissions for an organization role
 */
export function addPermissionsForOrganizationRole(roleId: string, body?: PermissionGrantsForPermission[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organization-roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace permissions of an organization role
 */
export function setPermissionsOfOrganizationRole(roleId: string, body?: PermissionGrantsForPermission[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organization-roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove permissions of an organization role
 */
export function removePermissionsOfOrganizationRole(roleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organization-roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a permission of an organization role
 */
export function getPermissionOfOrganizationRole(roleId: string, permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalPermissionWithGrantedActions;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organization-roles/${encodeURIComponent(roleId)}/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts
    });
}
/**
 * Remove a permission of an organization role
 */
export function removePermissionOfOrganizationRole(roleId: string, permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organization-roles/${encodeURIComponent(roleId)}/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List organizations
 */
export function listOrganizations({ offset, limit, order, asc, filter }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
    filter?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Organization[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations${QS.query(QS.explode({
        filter
    }))}`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create an organization
 */
export function createOrganization(organization: Organization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/organizations", oazapfts.json({
        ...opts,
        method: "POST",
        body: organization
    }));
}
/**
 * Replace an organization's details
 */
export function replaceOrganization(organization: Organization, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>("/organizations", oazapfts.json({
        ...opts,
        method: "PUT",
        body: organization
    }));
}
/**
 * Set up an organization
 */
export function setupOrganization(organization: Organization, { initialAdminId, createDefaultEntitlement }: {
    initialAdminId?: string;
    createDefaultEntitlement?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: CreatedOrganizationWithEntitlement;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organizations/organization-setup${QS.query(QS.explode({
        initialAdminId,
        createDefaultEntitlement
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: organization
    }));
}
/**
 * Get an organization
 */
export function getOrganization(organizationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Organization;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}`, {
        ...opts
    });
}
/**
 * Delete an organization
 */
export function deleteOrganization(organizationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List an organization's invitations
 */
export function listOrganizationsOrganizationGroupInvitations(organizationId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/group-invitations`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Get an organization invitation
 */
export function getOrganizationsOrganizationGroupInvitation(organizationId: string, invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/group-invitations/${encodeURIComponent(invitationId)}`, {
        ...opts
    });
}
/**
 * List an organization's user groups
 */
export function listOrganizationGroups(organizationId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroup[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/groups`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a user group
 */
export function createOrganizationGroup(organizationId: string, organizationGroup: OrganizationGroup, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: OrganizationGroup;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/groups`, oazapfts.json({
        ...opts,
        method: "POST",
        body: organizationGroup
    }));
}
/**
 * Replace a user group's details
 */
export function replaceOrganizationGroup(organizationId: string, organizationGroup: OrganizationGroup, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroup;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/groups`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: organizationGroup
    }));
}
/**
 * Get a user group
 */
export function getOrganizationGroup(organizationId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroup;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}`, {
        ...opts
    });
}
/**
 * Delete a user group
 */
export function deleteOrganizationGroup(organizationId: string, groupId: string, { cleanUpLicenseReservations, returnNoMembershipsUserIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsUserIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsUserIds
    }))}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List a user group's users
 */
export function listUsersInOrganizationGroup(organizationId: string, groupId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add users to a user group
 */
export function addUsersToOrganizationGroup(organizationId: string, groupId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace a user group's users
 */
export function setUsersInOrganizationGroup(organizationId: string, groupId: string, body: string[], { cleanUpLicenseReservations, returnNoMembershipsUserIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsUserIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsUserIds
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove users from a user group
 */
export function removeUsersFromOrganizationGroup(organizationId: string, groupId: string, body: string[], { cleanUpLicenseReservations, returnNoMembershipsUserIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsUserIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsUserIds
    }))}`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a user group's user
 */
export function getUserInOrganizationGroup(organizationId: string, groupId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}`, {
        ...opts
    });
}
/**
 * Add a user to a user group
 */
export function addUserToOrganizationGroup(organizationId: string, groupId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a user from a user group
 */
export function removeUserFromOrganizationGroup(organizationId: string, groupId: string, userId: string, { cleanUpLicenseReservations, returnNoMembershipsUserIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsUserIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsUserIds
    }))}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List organization roles
 */
export function listOrganizationRoles(organizationId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create an organization role
 */
export function createOrganizationRole(organizationId: string, organizationRole: OrganizationRole, { impliedOrganizationRoleId }: {
    impliedOrganizationRoleId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: OrganizationRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles${QS.query(QS.explode({
        impliedOrganizationRoleId
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: organizationRole
    }));
}
/**
 * Replace data of an organization role
 */
export function replaceOrganizationRole(organizationId: string, organizationRoleWithPermissionsWithGrantedActions: OrganizationRoleWithPermissionsWithGrantedActions, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: organizationRoleWithPermissionsWithGrantedActions
    }));
}
/**
 * List organization role member client roles
 */
export function listClientRolesInOrganizationRole(organizationId: string, organizationRoleId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add client roles to an organization role
 */
export function addClientRolesToOrganizationRole(organizationId: string, organizationRoleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace client role members of an organization role
 */
export function setClientRolesInOrganizationRole(organizationId: string, organizationRoleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove client roles from an organization role
 */
export function removeClientRolesFromOrganizationRole(organizationId: string, organizationRoleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a client role of an organization role
 */
export function getClientRoleInOrganizationRole(organizationId: string, organizationRoleId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles/${encodeURIComponent(roleId)}`, {
        ...opts
    });
}
/**
 * Add a client role to an organization role
 */
export function addClientRoleToOrganizationRole(organizationId: string, organizationRoleId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a client role from an organization role
 */
export function removeClientRoleFromOrganizationRole(organizationId: string, organizationRoleId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(organizationRoleId)}/client-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List organization role member roles
 */
export function listOrganizationRolesInOrganizationRole(organizationId: string, parentRoleId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add organization roles to an organization role
 */
export function addOrganizationRolesToOrganizationRole(organizationId: string, parentRoleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace organization role members of an organization role
 */
export function setOrganizationRolesInOrganizationRole(organizationId: string, parentRoleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove organization roles from an organization role
 */
export function removeOrganizationRolesFromOrganizationRole(organizationId: string, parentRoleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get an organization role of an organization role
 */
export function getOrganizationRoleInOrganizationRole(organizationId: string, parentRoleId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts
    });
}
/**
 * Add an organization role to an organization role
 */
export function addOrganizationRoleToOrganizationRole(organizationId: string, parentRoleId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove an organization role from an organization role
 */
export function removeOrganizationRoleFromOrganizationRole(organizationId: string, parentRoleId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(parentRoleId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Get an organization role
 */
export function getOrganizationRole(organizationId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts
    });
}
/**
 * Delete an organization role
 */
export function deleteOrganizationRole(organizationId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List organization role members
 */
export function listUsersInOrganizationRole(organizationId: string, roleId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add users to an organization role
 */
export function addUsersToOrganizationRole(organizationId: string, roleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace members of a role
 */
export function setUsersInOrganizationRole(organizationId: string, roleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove users from a role
 */
export function removeUsersFromOrganizationRole(organizationId: string, roleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a user of an organization role
 */
export function getUserInOrganizationRole(organizationId: string, roleId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users/${encodeURIComponent(userId)}`, {
        ...opts
    });
}
/**
 * Add a user to an organization role
 */
export function addUserToOrganizationRole(organizationId: string, roleId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users/${encodeURIComponent(userId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a user from a role
 */
export function removeUserFromOrganizationRole(organizationId: string, roleId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/organization-roles/${encodeURIComponent(roleId)}/users/${encodeURIComponent(userId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List an organization's properties
 */
export function listOrganizationProperties(organizationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Property[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/properties`, {
        ...opts
    });
}
/**
 * Replace an organization's properties
 */
export function replaceOrganizationProperties(organizationId: string, body: Property[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Property[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/properties`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List an organization's users
 */
export function listOrganizationUsers(organizationId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/users`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Import users to an organization
 */
export function importOrganizationUsers(organizationId: string, body: UserForCreate[], { allowUpdateExisting, errorHandlingMode }: {
    allowUpdateExisting?: boolean;
    errorHandlingMode?: "failImmediately" | "failWithErrors" | "skipErrors";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserForCreate[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/users/import${QS.query(QS.explode({
        allowUpdateExisting,
        errorHandlingMode
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Get an organization's user
 */
export function getOrganizationUser(organizationId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/organizations/${encodeURIComponent(organizationId)}/users/${encodeURIComponent(userId)}`, {
        ...opts
    });
}
/**
 * Remove a user from an organization
 */
export function removeUserFromOrganization(organizationId: string, userId: string, { deleteInvitations }: {
    deleteInvitations?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/organizations/${encodeURIComponent(organizationId)}/users/${encodeURIComponent(userId)}${QS.query(QS.explode({
        deleteInvitations
    }))}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List permissions
 */
export function listPermissions({ offset, limit, order, asc, domain }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
    domain?: "organization";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Permission[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/permissions${QS.query(QS.explode({
        domain
    }))}`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a permission
 */
export function createPermission(permission: Permission, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: Permission;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/permissions", oazapfts.json({
        ...opts,
        method: "POST",
        body: permission
    }));
}
/**
 * Replace a permission
 */
export function replacePermission(permission: Permission, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Permission;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>("/permissions", oazapfts.json({
        ...opts,
        method: "PUT",
        body: permission
    }));
}
/**
 * Get a permission
 */
export function getPermission(permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Permission;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts
    });
}
/**
 * Delete a permission
 */
export function deletePermission(permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List roles
 */
export function listRoles({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>("/roles", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a role
 */
export function createRole(internalRole: InternalRole, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: InternalRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/roles", oazapfts.json({
        ...opts,
        method: "POST",
        body: internalRole
    }));
}
/**
 * Replace data of a role
 */
export function replaceRole(internalRole: InternalRole, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>("/roles", oazapfts.json({
        ...opts,
        method: "PUT",
        body: internalRole
    }));
}
/**
 * Get a role
 */
export function getRole(roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/roles/${encodeURIComponent(roleId)}`, {
        ...opts
    });
}
/**
 * Delete a role
 */
export function deleteRole(roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List permissions of a role
 */
export function listPermissionsOfRole(roleId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalPermissionWithGrantedActions[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/roles/${encodeURIComponent(roleId)}/permissions`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add permissions for a role
 */
export function addPermissionsForRole(roleId: string, body?: PermissionGrantsForPermission[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace permissions of a role
 */
export function setPermissionsOfRole(roleId: string, body?: PermissionGrantsForPermission[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove permissions of a role
 */
export function removePermissionsOfRole(roleId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/roles/${encodeURIComponent(roleId)}/permissions`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a permission of a role
 */
export function getPermissionOfRole(roleId: string, permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalPermissionWithGrantedActions;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/roles/${encodeURIComponent(roleId)}/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts
    });
}
/**
 * Remove a permission of a role
 */
export function removePermissionOfRole(roleId: string, permissionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/roles/${encodeURIComponent(roleId)}/permissions/${encodeURIComponent(permissionId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List invitations
 */
export function listUserInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create an invitation
 */
export function createUserInvitation(userInvitation: UserInvitation, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: UserInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations", oazapfts.json({
        ...opts,
        method: "POST",
        body: userInvitation
    }));
}
/**
 * Accept an invitation
 */
export function acceptUserInvitation(body: {
    token: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations/accept", oazapfts.form({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List accepted invitations
 */
export function listAcceptedUserInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations/accepted", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Decline an invitation
 */
export function declineUserInvitation(body: {
    token: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations/decline", oazapfts.form({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List declined invitations
 */
export function listDeclinedUserInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations/declined", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * List open invitations
 */
export function listOpenUserInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations/open", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * List revoked invitations
 */
export function listRevokedUserInvitations({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/user-invitations/revoked", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Get an invitation
 */
export function getUserInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/user-invitations/${encodeURIComponent(invitationId)}`, {
        ...opts
    });
}
/**
 * Delete an invitation
 */
export function deleteUserInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/user-invitations/${encodeURIComponent(invitationId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Create an invitation token
 */
export function createUserInvitationToken(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InvitationTokenResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/user-invitations/${encodeURIComponent(invitationId)}/create-token`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Revoke an invitation
 */
export function revokeUserInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/user-invitations/${encodeURIComponent(invitationId)}/revoke`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Send an invitation
 */
export function sendUserInvitation(invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/user-invitations/${encodeURIComponent(invitationId)}/send`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * List users
 */
export function listUsers({ offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/users", {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a user
 */
export function createUser(userForCreate: UserForCreate, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: UserForCreate;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>("/users", oazapfts.json({
        ...opts,
        method: "POST",
        body: userForCreate
    }));
}
/**
 * Replace a user's details
 */
export function replaceUser(user: User, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>("/users", oazapfts.json({
        ...opts,
        method: "PUT",
        body: user
    }));
}
/**
 * Import users
 */
export function importUsers(body: UserForCreate[], { allowUpdateExisting, errorHandlingMode }: {
    allowUpdateExisting?: boolean;
    errorHandlingMode?: "failImmediately" | "failWithErrors" | "skipErrors";
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserForCreate[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/users/import${QS.query(QS.explode({
        allowUpdateExisting,
        errorHandlingMode
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Mark a user's recovery email as valid
 */
export function validateUserRecoveryEmail(body: {
    email: string;
    token: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: RecoveryEmail;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>("/users/recovery-emails/validate", oazapfts.form({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Get a user
 */
export function getUser(userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}`, {
        ...opts
    });
}
/**
 * Delete a user
 */
export function deleteUser(userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List a user's organizations through roles
 */
export function listAuthorizedOrganizationsOfUser(userId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Organization[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/authorized-organizations`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Change a user's login email
 */
export function changeEmail(userId: string, body?: {
    password?: string;
    email: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/changeEmail`, oazapfts.form({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List a user's organization invitations
 */
export function listUsersOrganizationGroupInvitations(userId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation[];
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/organization-group-invitations`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Get a user's organization invitation
 */
export function getUsersOrganizationGroupInvitation(userId: string, invitationId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupInvitation;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/organization-group-invitations/${encodeURIComponent(invitationId)}`, {
        ...opts
    });
}
/**
 * List a user's user groups
 */
export function listOrganizationGroupsOfUser(userId: string, { offset, limit, order, asc, organizationId }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
    organizationId?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupOfUser[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/organization-groups${QS.query(QS.explode({
        organizationId
    }))}`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add a user to user groups
 */
export function addOrganizationGroupsForUser(userId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-groups`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace a user's user groups
 */
export function setOrganizationGroupsOfUser(userId: string, body: string[], { cleanUpLicenseReservations, returnNoMembershipsOrgIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsOrgIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-groups${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsOrgIds
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove a user from user groups
 */
export function removeOrganizationGroupsOfUser(userId: string, body: string[], { cleanUpLicenseReservations, returnNoMembershipsOrgIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsOrgIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-groups${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsOrgIds
    }))}`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a user's user group
 */
export function getOrganizationGroupOfUser(userId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupOfUser;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/organization-groups/${encodeURIComponent(groupId)}`, {
        ...opts
    });
}
/**
 * Add a user to a user group
 */
export function addOrganizationGroupForUser(userId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a user from a user group
 */
export function removeOrganizationGroupOfUser(userId: string, groupId: string, { cleanUpLicenseReservations, returnNoMembershipsOrgIds }: {
    cleanUpLicenseReservations?: boolean;
    returnNoMembershipsOrgIds?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-groups/${encodeURIComponent(groupId)}${QS.query(QS.explode({
        cleanUpLicenseReservations,
        returnNoMembershipsOrgIds
    }))}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List a user's organization roles
 */
export function listOrganizationRolesOfUser(userId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/organization-roles`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add organization roles for a user
 */
export function addOrganizationRolesForUser(userId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace a user's organization roles
 */
export function setOrganizationRolesOfUser(userId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove organization roles from a user
 */
export function removeOrganizationRolesOfUser(userId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-roles`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a user's organization role
 */
export function getOrganizationRoleOfUser(userId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts
    });
}
/**
 * Add an organization role for a user
 */
export function addOrganizationRoleForUser(userId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove an organization role from a user
 */
export function removeOrganizationRoleOfUser(userId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/organization-roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List a user's properties
 */
export function listUserProperties(userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Property[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/properties`, {
        ...opts
    });
}
/**
 * Replace a user's properties
 */
export function replaceUserProperties(userId: string, body: Property[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Property[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/properties`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List a user's recovery emails
 */
export function listUserRecoveryEmails(userId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: RecoveryEmail[];
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/recovery-emails`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Create a recovery email for a user
 */
export function createUserRecoveryEmail(userId: string, recoveryEmail: RecoveryEmail, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: RecoveryEmail;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/recovery-emails`, oazapfts.json({
        ...opts,
        method: "POST",
        body: recoveryEmail
    }));
}
/**
 * Replace a user's recovery email data
 */
export function replaceUserRecoveryEmail(userId: string, recoveryEmail: RecoveryEmail, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: RecoveryEmail;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/recovery-emails`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: recoveryEmail
    }));
}
/**
 * Get a user's recovery email
 */
export function getUserRecoveryEmail(userId: string, emailId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: RecoveryEmail;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/recovery-emails/${encodeURIComponent(emailId)}`, {
        ...opts
    });
}
/**
 * Delete a user's recovery email
 */
export function deleteUserRecoveryEmail(userId: string, emailId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/recovery-emails/${encodeURIComponent(emailId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Create a recovery email validation token
 */
export function createUserRecoveryEmailValidationToken(userId: string, emailId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ValidationTokenResponse;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/recovery-emails/${encodeURIComponent(emailId)}/create-token`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Create a recovery email validation token and send a verification email
 */
export function sendUserRecoveryEmailValidation(userId: string, emailId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: RecoveryEmail;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/recovery-emails/${encodeURIComponent(emailId)}/send-validation`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * List a user's internal roles
 */
export function listRolesOfUser(userId: string, { offset, limit, order, asc }: {
    offset?: number;
    limit?: number;
    order?: string;
    asc?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalRole[];
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/roles`, {
        ...opts,
        headers: {
            ...opts && opts.headers,
            offset: offset !== undefined ? String(offset) : undefined,
            limit: limit !== undefined ? String(limit) : undefined,
            order,
            asc: asc !== undefined ? String(asc) : undefined
        }
    });
}
/**
 * Add internal roles for a user
 */
export function addRolesForUser(userId: string, body?: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Replace a user's internal roles
 */
export function setRolesOfUser(userId: string, body?: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/roles`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Remove internal roles from a user
 */
export function removeRolesOfUser(userId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/roles`, oazapfts.json({
        ...opts,
        method: "DELETE",
        body
    }));
}
/**
 * Get a user's internal role
 */
export function getRoleOfUser(userId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: InternalRole;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/roles/${encodeURIComponent(roleId)}`, {
        ...opts
    });
}
/**
 * Add an internal role for a user
 */
export function addRoleForUser(userId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove an internal role from a user
 */
export function removeRoleOfUser(userId: string, roleId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Get a user's TOTP credentials
 */
export function getOtpCredential(userId: string, { expand }: {
    expand?: "qrCode"[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OtpCredential;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/security/totp${QS.query(QS.explode({
        expand
    }))}`, {
        ...opts
    });
}
/**
 * Check if a user has TOTP credentials
 */
export function userHasOtpCredential(userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/security/totp`, {
        ...opts,
        method: "HEAD"
    });
}
/**
 * Create TOTP credentials for a user
 */
export function createOtpCredential(userId: string, { expand }: {
    expand?: "qrCode"[];
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: OtpCredential;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/security/totp${QS.query(QS.explode({
        expand
    }))}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Delete a user's TOTP credentials
 */
export function deleteOtpCredential(userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/security/totp`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Get a user's TOTP credentials as a QR code
 */
export function getMfaImage(userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/security/totp/qr`, {
        ...opts
    });
}
/**
 * Verify a user's TOTP credentials
 */
export function verifyOtpCredential(userId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/security/totp/verify`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Activate or suspend a user
 */
export function setUserActive(userId: string, status: boolean, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: User;
    } | {
        status: 400;
    } | {
        status: 401;
    } | {
        status: 403;
    } | {
        status: 404;
    } | {
        status: 500;
    }>(`/users/${encodeURIComponent(userId)}/setActive/${encodeURIComponent(status)}`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Set a user's password
 */
export function setPassword(userId: string, body: {
    password: string;
    validate?: boolean;
    resetExisting?: boolean;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/setPassword`, oazapfts.form({
        ...opts,
        method: "POST",
        body
    }));
}
/**
 * Mark a user's contact email as valid
 */
export function validateEmail(userId: string, body: {
    email: string;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText(`/users/${encodeURIComponent(userId)}/validateEmail`, oazapfts.form({
        ...opts,
        method: "POST",
        body
    }));
}
